import React from 'react';
import { useEffect } from 'react';
import useStore from './store/useStore';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';


//import Home from './components/views/Home';
//import NavBreadCrumb from './components/views/NavBreadCrumb';



import './App.css';
import './BannerEventSessions.css';
import HomeEvents from './components/views/HomeEvents';
import HomeSessions from './components/views/HomeSessions';
import CalendarViewEvents from './components/views/CalendarViewEvents';



//useful when deploying the app into a subfolder
//PUBLIC_URL is defined in the package.json (variable homepage)
const getBaseName = () => {
  if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    // dev code
    return ""
  } else {
    // production code
    return process.env.PUBLIC_URL
  }

}
const App: React.FC = () => {
  const {
    updateSettings,
    settings,

    //view /*filters, view, settings*/
  } = useStore((state: any) => ({
    updateSettings: state.updateSettings,
    settings: state.settings
  }));


  //console.log(view)
  const activeRoute = useStore((store: any) => store.activeRoute);
  const view = useStore((store: any) => store.view);

  useEffect(() => {
    const getWPSettings = async () => {
      await updateSettings();
    };

    getWPSettings();

  }, [updateSettings]);

  return (
    <>
      {/* display HomeEvents or HomeSessions component */}
      {settings.params.type === 'events' && settings.params.eventid === '' ?
        <HomeEvents />
        :
        <HomeSessions />}
    </>

    /* <Router basename={getBaseName()}>
       <div>
         <Routes>
           <Route path="/calendar/events" element={<CalendarViewEvents />} />
           <Route path="/" element={<HomeEvents />} />
           <Route path="/sessions/daily" element={<HomeSessions />} />
           <Route path="/sessions/:eventId" element={<HomeSessions />} />
 
         </Routes>
       </div>
     </Router>*/

  );
};

export default App;
